import React from 'react';
import { actions } from '../../store/index';

// import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import './Sell.css';

import { Form, Row, Col, Icon, Input, Button } from 'antd';

const FormItem = Form.Item;
const dimension = 18;

// const mapStateToProps = state => ({});
// const bid = async () => {

// };

const _acceptBid = async (params) => {
  await actions.acceptBid();
  window.location.href = window.location.href;
};

const hasErrors = fieldsError =>
  Object.keys(fieldsError).some(field => fieldsError[field]);

const newLocal = 1.1;
// @Form.create()
// @connect(mapStateToProps)
class Sell extends React.Component {
  static propTypes = {
    state: PropTypes.string,
    isRenter: PropTypes.bool.isRequired,
    bidder: PropTypes.string,
    price: PropTypes.string,
    form: PropTypes.object,
    getFieldDecorator: PropTypes.object,
    setFieldsValue: PropTypes.object,
  };

  state = {
    visible: false,
  };

  componentWillMount() {
    this.props.form.validateFields();
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps = (newProps) => {
    if (
      !newProps.state ||
      (newProps.state &&
        (newProps.state === 'rent' && newProps.isRenter) &&
        !!newProps.bidder)
    ) {
      this.setState({ visible: true });
    } else {
      this.setState({ visible: false });
    }
  };

  handleAmountChange = value =>
    this.props.form.setFieldsValue({
      amount: value,
    });

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        _acceptBid();
      }
    });
  };

  render() {
    const loading = false;
    const {
      getFieldDecorator,
      getFieldsError,
      isFieldTouched,
      getFieldError,
    } = this.props.form;
    const price = this.props.price / Math.pow(10, dimension);

    const amountError = isFieldTouched('amount') && getFieldError('amount');
    return (
      <div>
        {' '}
        {this.state.visible ? (
          <div className="b-form">
            <span>{`You can sell this billboards at ${price}`}</span>

            <Form layout="inline" onSubmit={this.handleSubmit}>
              <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                >
                  Sell
                </Button>
              </FormItem>
            </Form>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default Form.create()(Sell);



// WEBPACK FOOTER //
// ./src/components/sell/Sell.js